export const ID14 = () => {
    return(
        <div>
            <h2 className="servicePage_title">1С:СИСТЕМА ВЗАИМОДЕЙСТВИЯ</h2>
            <div className="content" readonly=""><h1>Система взаимодействия</h1>

                <p>
                    Система взаимодействия позволяет пользователям программ «1С:Предприятия» обмениваться текстовыми
                    сообщениями, файлами, устраивать аудио и видеоконференции.
                    Начиная с версии 8.3.16 есть возможность демонстрировать экран своего компьютера непосредственно в
                    окне прикладного решения.
                </p>

                <p>
                    Поддерживаются контекстные обсуждения, связанные с конкретными объектами приложения (документами,
                    элементами справочников, отчетами и т. п.). При этом вся
                    переписка сохраняется вместе с объектом приложения и отображается вместе с ним. С помощью Системы
                    взаимодействия разработчики прикладных решений могут
                    реализовывать новые, ранее недоступные бизнес-сценарии, например, создавать чат-боты и
                    автоматические ассистенты, облегчающие работу с приложениями,
                    информировать пользователей о событиях, произошедших в приложении и т. п. Система взаимодействия
                    может интегрироваться с мессенджером Telegram и социальной
                    сетью ВКонтакте, что может быть использовано для реализации широкого круга бизнес-сценариев. Система
                    взаимодействия доступна также в мобильном клиенте
                    «1С:Предприятия 8».
                </p>

                <h2>Архитектура</h2>
                <p>
                    Механизм обсуждений реализован в клиент-серверной архитектуре. Для взаимодействия между
                    пользователями используется отдельный программный продукт —
                    1С:Сервер взаимодействия. Он может быть развёрнут в Интернете или в локальной сети предприятия.
                </p>

                <h2>Обсуждения</h2>
                <p>
                    Взаимодействие между пользователями осуществляется с помощью обсуждений. По своему прикладному
                    смыслу обсуждения могут быть двух разных видов. Во-первых,
                    это тематические обсуждения, посвященные какому-либо вопросу: мероприятиям, связанным с открытием
                    нового магазина, вариантам проведения новогоднего
                    праздника или грядущему совещанию у директора.
                </p>

                <p>
                    Во-вторых, это могут быть обсуждения, связанные с конкретными объектами данных: накладными,
                    товарами, поставщиками и т. д. При этом вся переписка
                    отображается в форме этих данных.
                </p>

                <h2>Видеозвонки</h2>
                <p>
                    Функциональность видеозвонков, при наличии микрофона, позволяет звонить другим пользователям и
                    общаться с ними голосом. А при наличии веб-камер пользователи
                    могут ещё и видеть друг друга.
                </p>

                <h2>Демонстрация экрана</h2>
                <p>Существует возможность демонстрации происходящего на экране компьютера в ходе видеозвонка. После
                    того, как пользователь нажмет</p>

                <p>
                    <strong>Начать показ экрана</strong>, у него закрывается окно видеозвонка, а в видеочаты остальных
                    участников звонка начинает транслироваться происходящее
                    на экране у «транслирующего» пользователя.
                </p>

                <h2>Совместное использование прикладных решений</h2>
                <p>
                    В рамках системы взаимодействия поддерживается одновременное использование нескольких прикладных
                    решений. В результате пользователи, работающие в одном
                    приложении (например, «Бухгалтерия предприятия») могут обмениваться сообщениями и видеозвонками с
                    пользователями других приложений (например, «Управление
                    нашей фирмой»). Для облегчения взаимодействия пользователей, использующих несколько прикладных
                    решений, используется программа «1С:Предприятие — оповещения
                    и запуск».
                </p>

                <h2>Внешние пользователи</h2>
                <p>
                    К системе взаимодействия можно подключать людей, которые не являются пользователями информационных
                    баз «1С:Предприятия». Для этого в составе сервера системы
                    взаимодействия существует сайт, интерфейс которого аналогичен интерфейсу системы взаимодействия с
                    некоторыми ограничениями.
                </p>

                <p>
                    Из системы взаимодействия можно отправить внешнему участнику приглашение, приняв которое он будет
                    переадресован на этот сайт и сможет участвовать в
                    обсуждениях, видеозвонках и демонстрациях экрана.
                </p>

                <p>Этим способом, например:</p>
                <ul>
                    <li>сотрудник HR-отдела может проводить интервью с кандидатом непосредственно из приложения 1С
                        (например, из «1С:Зарплата и управление персоналом»);
                    </li>
                    <li>менеджер может подключать внешних пользователей (клиентов, контрагентов) к обсуждениям и
                        видеозвонкам, проходящим в системе взаимодействия;
                    </li>
                    <li>специалист-консультант может давать пояснения внешним пользователям, которые в ходе видеозвонка
                        демонстрируют ему свой экран;
                    </li>
                </ul>

                <h2>Интеграция с мессенджером Telegram и социальной сетью ВКонтакте</h2>
                <p>
                    Взаимодействие с мессенджером Telegram осуществляется через Telegram-бота. Администратор
                    «1С:Предприятия» должен создать такого бота в Telegram и затем
                    зарегистрировать его в системе взаимодействия. Обмен сообщениями выглядит следующим образом.
                    Пользователь Telegram пишет сообщение боту, система
                    взаимодействия создает нового внешнего пользователя (если такого еще нет) и новое неконтекстное
                    обсуждение (если такого еще нет). Участниками этого
                    обсуждения являются внешний пользователь и пользователи системы взаимодействия, назначенные для
                    участия во внешних обсуждениях. При появлении новых
                    сообщений в этом обсуждении пользователи системы взаимодействия получают уведомления по общим
                    правилам, а внешний пользователь получает сообщение в Telegram
                    от бота. Взаимодействие с социальной сетью ВКонтакте организуется другим образом — на основе
                    идентификатора группы ВКонтакте и ключа доступа. Во встроенном
                    языке реализована объектная модель, позволяющая управлять интеграцией системы взаимодействия с
                    внешними системами.
                </p>

                <h2>Интеграция с мессенджером WhatsApp</h2>
                <p>
                    Можно интегрировать систему взаимодействия с мессенджером WhatsApp через бизнес-аккаунт,
                    подключаемый к системе взаимодействия. На стороне WhatsApp
                    пользователи будут общаться с одним и тем же бизнес-аккаунтом, а в системе взаимодействия каждого
                    пользователя будет видно индивидуально. В панели
                    обсуждений у таких пользователей сверху будет написано имя контакта в WhatsApp, а снизу –
                    наименование соответствующей интеграции в системе взаимодействия;
                </p>

                <h2>Интеграция с произвольным приложением через механизм вебхуков (webhook)</h2>
                <p>
                    При таком способе интеграции внешние приложения могут посылать POST-запросы в формате JSON на адрес
                    точки подключения и создавать или обновлять в системе
                    взаимодействия пользователей, обсуждения и сообщения. Такое общение является односторонним — от
                    внешнего приложения в систему взаимодействия.
                </p>
                <ul>
                    <li>интернет-магазин может сообщать менеджерам-пользователям 1С о поступлении новых заказов;</li>
                    <li>агрегатор уведомлений из государственных органов может информировать юристов компании об
                        изменении законодательства;
                    </li>
                </ul>

                <h2>Боты</h2>
                <p>
                    Платформа «1С:Предприятие» содержит специальные объекты, боты, которые позволяют организовать
                    общение пользователя с прикладным решением через систему
                    взаимодействия. Например, пользователь может задать боту вопрос и узнать текущий курс валюты или
                    получить информацию об остатках определенных товаров или
                    сведения о контрагентах.
                </p>

                <h2>Встраивание чата системы взаимодействия в сторонний сайт</h2>
                <p>
                    Чат системы взаимодействия можно встраивать в сторонние сайты. Например, можно встроить его в сайт
                    интернет-магазина. Посетители сайта смогут общаться с
                    менеджерами, работающими в приложении 1С: получать консультации, ответы на вопросы, при
                    необходимости — пообщаться с помощью аудио/видеозвонка. Другой
                    пример — встроить чат в сайт техподдержки и решать возникшие у пользователя проблемы при помощи
                    видеозвонков и демонстрации экрана. На вопросы в чате могут
                    отвечать как сотрудники, так и боты, например, в нерабочее время;
                </p>

                <h2>Функциональность системы взаимодействия</h2>
                <ul>
                    <li>поддерживается обмен файлами и&nbsp;картинками в&nbsp;сообщениях;</li>
                    <li>поддерживаются групповые видеоконференции;</li>
                    <li>поддерживаются обсуждения «один на&nbsp;один». Они позволяют пользователям общаться только друг
                        с&nbsp;другом;
                    </li>
                    <li>
                        поддерживается история сообщений.&nbsp;Она позволяет увидеть сообщения из разных обсуждений за
                        указанную дату (включая контекстные обсуждения), отобрать
                        их по автору и выполнить поиск по тексту сообщения;
                    </li>
                    <li>
                        поддерживаются статусы пользователя
                        (<strong>не&nbsp;в&nbsp;сети</strong>,&nbsp;<strong>отошел</strong>,&nbsp;
                        <strong>не&nbsp;беспокоить</strong>,&nbsp;<strong>доступен</strong>);
                    </li>
                    <li>в&nbsp;сообщениях можно использовать «смайлики». С&nbsp;помощью смайликов, например, можно
                        обмениваться сообщениями без текста;
                    </li>
                    <li>можно назначить альтернативное сочетание клавиш, которое будет использоваться для отправки
                        сообщений;
                    </li>
                    <li>
                        можно редактировать и&nbsp;удалять сообщения, редактировать заголовки обсуждений. Редактирование
                        обсуждений сопровождается служебными
                        сообщениями&nbsp;<strong>Печатает</strong>&nbsp;остальным участникам обсуждения;
                    </li>
                    <li>поддерживается цитирование сообщений;</li>
                    <li>появление нового сообщения и&nbsp;входящий звонок сопровождаются звуковым оповещением;</li>
                    <li>поддерживаются push уведомления;</li>
                    <li>если соединение с&nbsp;сервером взаимодействия отсутствовало, а&nbsp;потом было восстановлено,
                        неотправленные сообщения отправляются автоматически;
                    </li>
                    <li>
                        осуществляется диагностика качества видеозвонков. Она позволяет фирме «1С» собирать
                        дополнительную техническую информацию в&nbsp;тех случаях, когда
                        возникают проблемы видеосвязи.
                    </li>
                </ul>
            </div>
        </div>
    )
}